// Duplo clique no icone de calendario de qualquer <input type="date"> preenche com a data de hoje
// (pedido do usuario em 08/10). Listener global, entao vale pra todas as telas sem mexer em cada uma.
//
// Nao da pra confiar so no evento 'dblclick': o 1o clique no icone abre o seletor nativo do
// navegador e o 2o clique as vezes nao chega como dblclick. Por isso conta dois cliques seguidos
// no icone (lado direito do campo) dentro de 500ms.

const LARGURA_ICONE = 34
const INTERVALO_MS = 500

const hojeISO = () => {
  const h = new Date()
  return `${h.getFullYear()}-${String(h.getMonth() + 1).padStart(2, '0')}-${String(h.getDate()).padStart(2, '0')}`
}

// Muda o valor de um jeito que o React percebe (dispara o onChange do componente controlado).
const definirValor = (el, valor) => {
  const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set
  setter.call(el, valor)
  el.dispatchEvent(new Event('input', { bubbles: true }))
  el.dispatchEvent(new Event('change', { bubbles: true }))
}

let ultimo = { el: null, t: 0 }

const noClique = (e) => {
  const el = e.target
  if (!(el instanceof HTMLInputElement) || el.type !== 'date' || el.disabled || el.readOnly) return
  const r = el.getBoundingClientRect()
  if (e.clientX < r.right - LARGURA_ICONE) { ultimo = { el: null, t: 0 }; return }
  const agora = Date.now()
  if (ultimo.el === el && agora - ultimo.t <= INTERVALO_MS) {
    ultimo = { el: null, t: 0 }
    definirValor(el, hojeISO())
    el.blur() // fecha o seletor nativo que o 1o clique abriu
    return
  }
  ultimo = { el, t: agora }
}

// === Dia + mes + Tab completa com o ano atual (pedido do usuario em 08/10) ===
// O <input type="date"> nativo nao expoe o que foi digitado enquanto a data esta incompleta (value
// fica ''), entao acompanha as teclas imitando os segmentos do Chrome (dd/mm/aaaa): 2 digitos ou
// um digito que nao pode comecar outro numero (dia > 3, mes > 1) avancam pro proximo segmento,
// assim como '/', '-', '.' e seta direita. Ao teclar Tab ja no segmento do ano, ainda vazio, com
// dia e mes digitados, preenche a data com o ano atual e deixa o Tab seguir pro proximo campo.
const estados = new WeakMap()
const novoEstado = () => ({ seg: 0, partes: ['', '', ''] })

const noFoco = (e) => {
  const el = e.target
  if (el instanceof HTMLInputElement && el.type === 'date') estados.set(el, novoEstado())
}

const noTeclado = (e) => {
  const el = e.target
  if (!(el instanceof HTMLInputElement) || el.type !== 'date' || el.disabled || el.readOnly) return
  const st = estados.get(el) || novoEstado()
  estados.set(el, st)
  const k = e.key

  if (/^\d$/.test(k)) {
    if (st.seg > 2) return
    const max = st.seg === 2 ? 4 : 2
    st.partes[st.seg] = (st.partes[st.seg].length >= max ? '' : st.partes[st.seg]) + k
    const p = st.partes[st.seg]
    if (st.seg === 0 && (p.length === 2 || +p > 3)) st.seg = 1
    else if (st.seg === 1 && (p.length === 2 || +p > 1)) st.seg = 2
    return
  }
  if (['/', '-', '.', 'ArrowRight'].includes(k)) { if (st.seg < 2 && st.partes[st.seg]) st.seg++; return }
  if (k === 'ArrowLeft') { if (st.seg > 0) st.seg--; return }
  if (k === 'Backspace' || k === 'Delete') { st.partes[st.seg] = ''; return }
  if (k === 'Tab' && !e.shiftKey) {
    if (st.seg === 0 || st.seg === 1) { st.seg++; return } // no Chrome, Tab anda entre os segmentos
    if (el.value || st.partes[2] || !st.partes[0] || !st.partes[1]) return
    const dia = +st.partes[0], mes = +st.partes[1], ano = new Date().getFullYear()
    const d = new Date(ano, mes - 1, dia)
    if (!dia || !mes || d.getMonth() !== mes - 1 || d.getDate() !== dia) return
    // Aplica so quando o campo perde o foco (o proprio Tab), pra nao atrapalhar a navegacao do Tab.
    st.pendente = `${ano}-${String(mes).padStart(2, '0')}-${String(dia).padStart(2, '0')}`
  }
}

const aoSair = (e) => {
  const el = e.target
  if (!(el instanceof HTMLInputElement) || el.type !== 'date') return
  const st = estados.get(el)
  if (st?.pendente && !el.value) definirValor(el, st.pendente)
  estados.delete(el)
}

export const ativarDataHojeDuploClique = () => {
  document.addEventListener('focusin', noFoco, true)
  document.addEventListener('keydown', noTeclado, true)
  document.addEventListener('focusout', aoSair, true)
  document.addEventListener('mousedown', noClique, true)
  // Reforco: se o navegador entregar o dblclick normalmente, tambem preenche.
  document.addEventListener('dblclick', (e) => {
    const el = e.target
    if (!(el instanceof HTMLInputElement) || el.type !== 'date' || el.disabled || el.readOnly) return
    if (e.clientX < el.getBoundingClientRect().right - LARGURA_ICONE) return
    if (el.value !== hojeISO()) definirValor(el, hojeISO())
    el.blur()
  }, true)
}
